import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
  string,
  array,
} from 'libs/form';

export interface IdentityDocumentFormType {
  fileIds: string[];
}
export const MAX_FILES = 10;

export const getSchema = (): ObjectSchema<IdentityDocumentFormType> =>
  object({
    fileIds: array().of(string().required()).required().min(1).max(MAX_FILES),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<IdentityDocumentFormType>();

export type FormErrors = FormErrorsBase<IdentityDocumentFormType>;
